import {TweenLite} from "gsap";

class Synopsis {

    constructor() {
        this.duration = 1
        this.synopsis = document.querySelector(".section-synopsis__text__inner__left__title")
        this.description = document.querySelector(".section-synopsis__text__inner__right")
    }

    init() {
        this.initTitle()
        this.initDesc()
    }

    initTitle() {
        const textContent = this
            .synopsis
            .textContent
            .split("")
        this.synopsis.innerHTML = ""
        this.synopsisDivs = []
        textContent.map((l, index) => {
            const classItem = (l === " ")
                ? "sy-space"
                : "sy-" + index
            const item = "<span class='" + classItem + "'>" + l + "</span>"
            this.synopsis.innerHTML += item

            l !== " " && (this.synopsisDivs.push(index))
        })
    }

    initDesc() {
        const textContent = this
            .description
            .innerHTML
            .split("<br>")

        this.description.innerHTML = ""
        this.descriptionDivs = []
        textContent.map((l, index) => {
            const classItem = "li-" + index
            const item = "<div class='" + classItem + "'>" + l + "</div>"
            if (l !== '') 
                this.description.innerHTML += item

            l !== "" && (this.descriptionDivs.push(index))
        })
    }

    getRandomInt(min, max) {
        return Math.random() * (max - min + 1) + min
    }

    initAnim() {
        this
            .synopsisDivs
            .map((l, index) => {
                TweenLite.fromTo(this.synopsis.querySelector(".sy-" + l), this.duration, {
                    y: 10 + 2 * index
                }, {
                    y: 0,
                    opacity: 1,
                    delay: this.getRandomInt(.1, (this.synopsisDivs.length - 1) * .00001),
                    force3D: true,
                    ease: Quint.easeInOut
                })
            })
        this.initAnimDesc()
    }

    initAnimDesc() {

        this
            .descriptionDivs
            .map((l, index) => {
                TweenLite.fromTo(this.description.querySelector(".li-" + l), this.duration, {
                    y: 70,
                    opacity: 0
                }, {
                    y: 0,
                    opacity: 1,
                    delay: .4 + index * .15,
                    force3D: true,
                    ease: Quint.easeInOut
                })
            })

    }

}

export default Synopsis


// WEBPACK FOOTER //
// ./src/js/components/Synopsis.js